// extracted by mini-css-extract-plugin
module.exports = {"input":"PlacePicker_input__aUZEc","placeName":"PlacePicker_placeName__3hpbY","placeRegion":"PlacePicker_placeRegion__0yhH_"};